import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDanger = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8583 13.4963L8.90735 1.45493C8.50444 0.757212 7.49554 0.757212 7.09263 1.45493L0.141683 13.4963C-0.261223 14.194 0.243229 15.0686 1.04904 15.0686H14.9509C15.7568 15.0686 16.2612 14.194 15.8583 13.4963ZM8.00982 5.16298C8.45531 5.16298 8.81563 5.53313 8.80253 5.97862L8.6715 10.5514C8.66168 10.9118 8.36687 11.1967 8.00654 11.1967C7.64622 11.1967 7.35141 10.9085 7.34159 10.5514L7.21383 5.97862C7.20401 5.53313 7.56105 5.16298 8.00982 5.16298ZM7.99999 13.434C7.54468 13.434 7.17453 13.0639 7.17453 12.6086C7.17453 12.1532 7.54468 11.7831 7.99999 11.7831C8.45531 11.7831 8.82546 12.1532 8.82546 12.6086C8.82546 13.0639 8.45531 13.434 7.99999 13.434Z",
		fill: "currentColor"
	})
});
export default SvgDanger;
